/**
 * コモンクラス
 * @constructor
 */
class SpAccordion {
    constructor() {

    }
    /**
     * コモン
     */
    init() {
      this.acrd();
    }
    acrd() {
        $('.l-contetens__bsListItemAccFunc').on('click', (e) => {
            $(e.currentTarget).toggleClass('is-active');
            $(e.currentTarget).next().slideToggle(400,()=>{
              this.frameSizeReset();
            });
        });
    }

  // iframe用の高さ設定の関数
  frameSizeReset() {
    if (typeof getHeightSize == 'function') {
      getHeightSize();
    }
  }
}

export default SpAccordion;
